// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect, useState} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {Footer} from './footer';
import {t_methods, t_states} from './types';
import {perr} from 'hola_pub_util';
import Chevron_left from '../../img/icons/24/chevron_left.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Brand_icon from '../../img/icons/24/color/brand.svg';
import {is_valid_email} from 'zurl';
import {login_process} from './utils';
import {Text_input} from '../../../../shared/ui/input';
import {Method_button} from './method_button';
import Email_icon from '../../img/icons/24/email.svg';
import Google_icon from '../../img/icons/24/color/google.svg';

interface i_login_buttons_props {
    on_click: (type:t_methods)=>void;
    go_to: (type:t_states, direction?: number)=>void;
    can_signup: boolean;
    blocks: {
        social?: {[propname: string]: boolean},
    };
    no_banner?: boolean;
    Banner?: JSX.Element;
    full_page: boolean;
    global_back?: boolean;
}

export const State_login_buttons = (props: i_login_buttons_props)=>{
    const {theme} = useContext(Settings_context);
    useEffect(()=>{ perr({id: 'www_login_view'}); }, []);
    const [email, set_email] = useState(()=>login_process.get('email') ?? '');
    const [error, set_error] = useState('');
    const handle_key_press = e=>{
        if (e.key === 'Enter')
            go_to_email_signup();
    };
    const go_to_email_signup = ()=>{
        if (!is_valid_email(email))
        {
            set_error('Invalid email address');
            return;
        }
        login_process.set('email', email);
        props.on_click('email');
    };
    return <div className={styles.form_content}>
      <div className={styles.first_slide_title}>
        {props.global_back && <button
          className={styles.back_btn}
          onClick={()=>{
            location.href = location.href + '&hide_login=true';
          }}><Chevron_left/></button>}
        <Brand_icon />
        <h4 className={cn(styles.title, theme.med, theme.color_n1100)}>
          Welcome to BrowserAI</h4>
        <p className={cn(theme.p14, theme.color_n800)}>
          Login to get access</p>
      </div>
      <div className={styles.first_slide_form}>
        <Text_input
          type="email"
          on_change={set_email}
          value={email}
          placeholder="name@email.com"
          error={error}
          is_error={!!error}
          input_props={{
            onKeyDown: handle_key_press,
            autoComplete: 'email',
          }}
          error_icon={null}
        />
        <Method_button type={'email'} color='primary' label='email'
          on_click={go_to_email_signup} signup_mode={false}>
          <Email_icon />
        </Method_button>
        <div className={styles.hl_text}>
          <hr/>OR<hr/>
        </div>
        <Method_button type={'google'} label='Google'
          on_click={props.on_click} signup_mode={false}>
          <Google_icon />
        </Method_button>
        {props.can_signup && <p className={cn(theme.p14,
          styles.login_signup_switch)}>
          Don't have an account? <a
            onClick={e=>{
              e.preventDefault();
              props.go_to('signup_buttons');
            }}
            href='#'>Sign up</a>
        </p>}
      </div>
      <Footer label={'Log in'}/>
    </div>;
};
